import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { AppDispatch, RootState } from '../store';
import { BucketImage } from '../../hooks/useBucketImage';
import { buildReducers, createRequestStatusObject, RequestStatusObject } from '../utils';

interface PreferencesState {
	categories: Record<string, BucketImage>;
	readRequest: RequestStatusObject;
	updateRequest: RequestStatusObject;
}

const initialState: PreferencesState = {
	categories: {},
	readRequest: createRequestStatusObject(),
	updateRequest: createRequestStatusObject()
};

export const readPreferences = createAsyncThunk<
	Record<string, string>,
	string | undefined,
	{ dispatch: AppDispatch; state: RootState }
>('preferences/fetchPreferences', async (_) => {
	const response = await API.get('inspirusapi', '/users/self/preferences', {});
	return response;
});

export const updatePreferences = createAsyncThunk<
	Record<string, BucketImage>,
	Record<string, BucketImage>,
	{ dispatch: AppDispatch; state: RootState }
>('preferences/updatePreferences', async (categories) => {
	const response = await API.put('inspirusapi', '/users/self/preferences', {
		headers: {},
		body: { categories }
	});
	return response.data;
});

const preferencesSlice = createSlice({
	name: 'preferences',
	initialState,
	reducers: {
		resetPreferences: () => initialState
	},
	extraReducers: (builder) => {
		buildReducers(builder, readPreferences, 'readRequest', {
			onFulfilled: (state, payload) => {
				state.categories = payload?.categories ?? {};
			}
		});
		buildReducers(builder, updatePreferences, 'updateRequest');
	}
});

export const { resetPreferences } = preferencesSlice.actions;
export default preferencesSlice.reducer;
